const config = {
    api: {
        baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
        timeout: 30000,
    },

    environment: process.env.REACT_APP_ENV || 'development',

    globalSettings: {
        signupRedirectUrl:
            process.env.REACT_APP_SIGNUP_REDIRECT_URL || "https://midamas-stage.axoneit.com/login",
    },
};

export default config;